export enum LocationType {
    BRAND = "BRAND",
}
